var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('header',{class:("card-header has-background-" + _vm.theme)},[_c('p',{staticClass:"card-header-title has-text-white"},[_vm._t("title")],2)]),_c('div',{staticClass:"card-content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }